import React from "react";
import { Layout } from "components";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DEFAULT_ROUTE } from "constants/route";

export default function CancelSuccess() {
  const navigate = useNavigate();
  const goHome = () => navigate(DEFAULT_ROUTE);

  return (
    <Layout>
      <div className="form-box">
        <div className="center fw-bold text-secondary mt-3">
          ALL APPOINTMENT SLOTS BOOKED
        </div>
        <div className="text-secondary mt-4 ps-3">
          Sorry, all appointment slots have been taken up. Please try booking
          again tomorrow or call our CPF Hotline 1800-227-1188 for Member
          related enquires or CPF Employer Hotline 6220-2340 for Employer
          related enquires.
        </div>
        <div className="form-footer">
          <Button
            className="btn cmp-button pbs-style--primary rounded-pill mt-5"
            onClick={goHome}
          >
            Home Page
          </Button>
        </div>
      </div>
    </Layout>
  );
}
